import React__default from 'react';
import { Card, Alert } from '@grandvisionhq/common';
import { Heading } from '@grandvisionhq/elements';
import { getICSEvent } from '@grandvisionhq/lib-ics';
import StoreDetailModal from '../StoreDetailModal/StoreDetailModal.js';

const AppointmentDetail = ({ appointmentType , cancelLink , child , customerComment , dateAndTime , directionsUrl , endTime , invitee , isReservation , isCancellable , isReschedulable , labels , mapImageUrl , onReschedule , onStoreDetailModalClose , onStoreDetailModalOpen , rescheduleLink , startTime , store , storeDetailModalOpen , isVirtualAppointmentType ,  })=>{
    var ref;
    return /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, /*#__PURE__*/ React__default.createElement(Card.Text, {
        color: "text-secondary"
    }, appointmentType === null || appointmentType === void 0 ? void 0 : appointmentType.name), /*#__PURE__*/ React__default.createElement(Heading, {
        variant: "small",
        component: "h2"
    }, dateAndTime), /*#__PURE__*/ React__default.createElement(Card.Section, null, isReservation ? /*#__PURE__*/ React__default.createElement(Alert, {
        type: "info",
        icon: "info",
        title: (ref = labels.reservationTitle) === null || ref === void 0 ? void 0 : ref.toString(),
        message: labels.reservationInfo
    }) : /*#__PURE__*/ React__default.createElement(Card.ButtonLayout, null, isReschedulable && rescheduleLink && /*#__PURE__*/ React__default.createElement(Card.Link, {
        href: rescheduleLink,
        onClick: onReschedule,
        iconBefore: "reschedule"
    }, labels.reschedule), isCancellable && cancelLink && /*#__PURE__*/ React__default.createElement(Card.Link, {
        href: cancelLink,
        iconBefore: "trash"
    }, labels.cancel))), /*#__PURE__*/ React__default.createElement(Card.Section, null, /*#__PURE__*/ React__default.createElement(Heading, {
        variant: "small",
        component: "h3"
    }, labels.when), /*#__PURE__*/ React__default.createElement(Card, null, /*#__PURE__*/ React__default.createElement(Card.Content, null, /*#__PURE__*/ React__default.createElement(Card.Section, null, /*#__PURE__*/ React__default.createElement(Card.Text, {
        variant: "body-head"
    }, dateAndTime)), store && appointmentType && startTime && endTime && !isReservation ? /*#__PURE__*/ React__default.createElement(Card.Section, null, /*#__PURE__*/ React__default.createElement(Card.Link, {
        iconAfter: "chevron-right",
        onClick: ()=>getICSEvent({
                description: appointmentType.description,
                timeSlot: {
                    from: startTime,
                    until: endTime
                },
                name: store.name,
                location: store,
                id: appointmentType.id
            })
    }, labels.addToCalendar)) : null))), !isVirtualAppointmentType && /*#__PURE__*/ React__default.createElement(Card.Section, null, /*#__PURE__*/ React__default.createElement(Heading, {
        variant: "small",
        component: "h3"
    }, labels.where), store && /*#__PURE__*/ React__default.createElement(Card, null, mapImageUrl && /*#__PURE__*/ React__default.createElement(Card.Image, {
        className: "appointment-detail__map",
        src: mapImageUrl,
        alt: store.name
    }), /*#__PURE__*/ React__default.createElement(Card.Content, null, /*#__PURE__*/ React__default.createElement(Card.Section, null, /*#__PURE__*/ React__default.createElement(Card.Text, {
        variant: "body-head"
    }, store.name), /*#__PURE__*/ React__default.createElement(Card.Text, {
        color: "text-secondary"
    }, store.streetName, " ", store.town), store.phone && /*#__PURE__*/ React__default.createElement(Card.Link, {
        href: `tel:${store.phone}`
    }, store.phone)), /*#__PURE__*/ React__default.createElement(Card.Section, null, /*#__PURE__*/ React__default.createElement(Card.ButtonLayout, null, /*#__PURE__*/ React__default.createElement(Card.Link, {
        onClick: onStoreDetailModalOpen,
        iconAfter: "chevron-right"
    }, labels.viewStoreDetails), directionsUrl && /*#__PURE__*/ React__default.createElement(Card.Link, {
        href: directionsUrl,
        iconAfter: "chevron-right"
    }, labels.getDirections), store && storeDetailModalOpen && /*#__PURE__*/ React__default.createElement(StoreDetailModal, {
        storeCode: store.code,
        onModalClose: onStoreDetailModalClose
    })))))), /*#__PURE__*/ React__default.createElement(Card.Section, null, /*#__PURE__*/ React__default.createElement(Heading, {
        variant: "small",
        component: "h3"
    }, labels.who), /*#__PURE__*/ React__default.createElement(Card, null, /*#__PURE__*/ React__default.createElement(Card.Content, null, /*#__PURE__*/ React__default.createElement(Card.Section, null, child && /*#__PURE__*/ React__default.createElement(Card.Text, {
        variant: "body-head"
    }, child.firstName, " ", child.lastName), /*#__PURE__*/ React__default.createElement(Card.Text, null, invitee === null || invitee === void 0 ? void 0 : invitee.firstName, " ", invitee === null || invitee === void 0 ? void 0 : invitee.lastName), /*#__PURE__*/ React__default.createElement(Card.Text, null, invitee === null || invitee === void 0 ? void 0 : invitee.email), /*#__PURE__*/ React__default.createElement(Card.Text, null, invitee === null || invitee === void 0 ? void 0 : invitee.phone)), customerComment && /*#__PURE__*/ React__default.createElement(Card.Section, null, /*#__PURE__*/ React__default.createElement(Card.Text, {
        variant: "body-head"
    }, labels.additionalInfo), /*#__PURE__*/ React__default.createElement(Card.Text, null, customerComment))))));
};
var AppointmentDetail$1 = AppointmentDetail;

export { AppointmentDetail$1 as default };
//# sourceMappingURL=AppointmentDetail.js.map
